__turbopack_context__.v({
  "illustration": "illustration-module-scss-module__XoHMzq__illustration",
});
